import React from 'react';
import { Alert, Tag, Typography } from 'antd';

const { Text } = Typography;

interface ComplianceIssue {
    type: 'error' | 'warning';
    word: string;
    suggestion: string;
    location: string;
}

interface ComplianceAlertProps {
    issues: ComplianceIssue[];
}

export const ComplianceAlert: React.FC<ComplianceAlertProps> = ({ issues }) => {
    if (issues.length === 0) return null;

    return (
        <Alert
            type={issues.some(i => i.type === 'error') ? 'error' : 'warning'}
            message={`发现 ${issues.length} 个合规问题`}
            description={
                <div style={{ marginTop: 8 }}>
                    {issues.map((issue, idx) => (
                        <div key={idx} style={{ marginBottom: 4 }}>
                            <Tag color={issue.type === 'error' ? 'red' : 'orange'}>
                                {issue.location}
                            </Tag>
                            <Text type={issue.type === 'error' ? 'danger' : 'warning'}>
                                "{issue.word}" - {issue.suggestion}
                            </Text>
                        </div>
                    ))}
                </div>
            }
            style={{ marginBottom: 16 }}
            showIcon
        />
    );
};
